import React from 'react';

type BookingStatus = 'pending' | 'confirmed' | 'inprogress' | 'completed' | 'cancelled' | 'noshow';

const statusConfig: Record<BookingStatus, { label: string; bg: string; color: string; dot: string }> = {
  pending: { label: 'Pending', bg: 'bg-[#FFFBEB]', color: 'text-[#B45309]', dot: 'bg-[#F59E0B]' },
  confirmed: { label: 'Confirmed', bg: 'bg-[#EEF2FF]', color: 'text-[#0F62FE]', dot: 'bg-[#0F62FE]' },
  inprogress: { label: 'In Progress', bg: 'bg-[#F5F3FF]', color: 'text-[#7C3AED]', dot: 'bg-[#8B5CF6]' },
  completed: { label: 'Completed', bg: 'bg-[#ECFDF5]', color: 'text-[#047857]', dot: 'bg-[#10B981]' },
  cancelled: { label: 'Cancelled', bg: 'bg-[#FEF2F2]', color: 'text-[#B91C1C]', dot: 'bg-[#EF4444]' },
  noshow: { label: 'No-Show', bg: 'bg-[#F9FAFB]', color: 'text-[#6B7280]', dot: 'bg-[#9CA3AF]' },
};

interface StatusBadgeProps {
  status: BookingStatus;
  size?: 'sm' | 'md';
}

export default function StatusBadge({ status, size = 'md' }: StatusBadgeProps) {
  const config = statusConfig[status];
  return (
    <span
      className={`status-badge ${config.bg} ${config.color} ${size === 'sm' ? 'text-[11px] px-2 py-0.5' : ''}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${config.dot} flex-shrink-0`} />
      {config.label}
    </span>
  );
}

export { statusConfig };
export type { BookingStatus };